/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
/* eslint-disable func-names */
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@postscript/components';
import PropTypes from 'prop-types';
import { useState } from 'react';

const DialogModal = function (props) {
  const {
    className = '',
    headerClassName = '',
    bodyClassName = '',
    footerClassName = '',
    children,
    startShown = false,
    title = null,
    yesCallback = () => true,
    yesProps = {},
    yesLabel = 'Yes',
    noProps = {},
    noLabel = 'No',
    noCallback = () => true,
    closeCallback = () => true,
  } = props;

  const [show, setShow] = useState(startShown);
  // The CL Modal has no `onClosed` post-animation lifecycle, so the cleanup
  // that reactstrap ran via `onClosed` now fires here on every close path.
  const handleClose = () => {
    setShow(false);
    closeCallback();
  };
  const clickBtn = (cb) => {
    const res = cb();
    // resolve the promise if necessary
    if (res instanceof Promise) {
      return res.then((r) => {
        // only close if truthy
        if (r || r === undefined) {
          handleClose();
        }
        return Promise.resolve(r);
      });
    }
    // truthy or undefined (meaning no return supplied)
    if (res || res === undefined) {
      handleClose();
    }
    return res;
  };

  return (
    <Modal isOpen={show} onCancel={handleClose} className={className}>
      {title ? (
        <ModalHeader
          className={headerClassName}
          onCancel={noCallback ? undefined : handleClose}
        >
          {title}
        </ModalHeader>
      ) : null}
      <ModalBody className={bodyClassName}>{children}</ModalBody>
      <ModalFooter className={footerClassName}>
        <Button
          {...yesProps}
          variant="primary"
          onClick={() => clickBtn(yesCallback)}
        >
          {yesLabel}
        </Button>
        {noCallback ? (
          <Button
            {...noProps}
            variant="text"
            onClick={() => clickBtn(noCallback)}
          >
            {noLabel}
          </Button>
        ) : null}
      </ModalFooter>
    </Modal>
  );
};

DialogModal.propTypes = {
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  startShown: PropTypes.bool,
  title: PropTypes.string,
  yesCallback: PropTypes.func,
  yesProps: PropTypes.object,
  yesLabel: PropTypes.string,
  noProps: PropTypes.object,
  noLabel: PropTypes.string,
  noCallback: PropTypes.func,
  closeCallback: PropTypes.func,
  children: PropTypes.node,
};

export default DialogModal;
